import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/*
  GET /tickets/transferencias?sprints=8
  Retorna os tickets que foram transferidos de uma sprint para outra,
  quantas vezes cada um foi transferido e, para os que ainda não
  entraram em desenvolvimento, há quanto tempo estão aguardando.

  Resposta esperada:
  {
    "periodo": { "sprints": 8, "versoes": ["20260601", "20260602", ...] },
    "resumo": {
      "tickets_transferidos": 12,
      "total_transferencias": 18,
      "max_transferencias": { "id": 217743, "qtd": 3 },
      "maior_espera_dias": { "id": 217700, "dias": 14.2 }
    },
    "fluxo_sprints": [ { "de": "20260530", "para": "20260601", "qtd": 5 }, ... ],
    "tickets": [
      { "id": 217743, "subject": "...", "status": "Aguardando Análise",
        "desenvolvedor": "Fulano", "size": "M", "grupo_entrega": "260602",
        "qtd_transferencias": 2, "historico_sprints": ["20260530","20260601","20260602"],
        "em_desenvolvimento": false, "tempo_aguardando_dias": 8.4 },
      ...
    ]
  }
*/
export async function getTransferencias(sprints = 8) {
  const { data } = await api.get(`/tickets/transferencias?sprints=${sprints}`);
  return data;
}
